<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-age.mr-2(ref="age" :filter.sync="ageFilter" check-initial-value)
    filter-id.mr-2(v-if="marketingSetting.plan === 'cms'" ref="nric" :filter.sync="idFilter" check-initial-value)
    filter-phone.mr-2(ref="phone" :filter.sync="phoneFilter" check-initial-value)
    filter-email.mr-2(ref="email" :filter.sync="emailFilter" check-initial-value)
    filter-segments.mr-2(ref="segment" :filter.sync="segmentFilter" check-initial-value)
    filter-visit-frequency.mr-2(ref="visitFrequency" :filter.sync="visitFrequencyFilter")
    filter-activity.mr-2(ref="activity" :filter.sync="activityFilter")
    filter-available-point-or-stamp.mr-2(ref="availablePointOrStamp" :filter.sync="availablePointOrStampFilter" :loyalty-system="marketingSetting.loyalty_system")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterId from '@/components/clinic/patient/filters/FilterId.vue'
import FilterPhone from '@/components/clinic/patient/filters/FilterPhone.vue'
import FilterEmail from '@/components/clinic/patient/filters/FilterEmail.vue'
import FilterSegments from '@/components/clinic/patient/filters/FilterSegments.vue'
import FilterAge from '@/components/module/filter/FilterAge.vue'
import FilterVisitFrequency from "@/components/clinic/marketing/filters/FilterVisitFrequency.vue";
import FilterActivity from "@/components/clinic/marketing/filters/FilterActivity.vue";
import FilterAvailablePointOrStamp from "@/components/clinic/marketing/filters/FilterAvailablePointOrStamp.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    FilterAvailablePointOrStamp, FilterActivity, FilterVisitFrequency, FilterName, FilterId, FilterPhone, FilterEmail, FilterAge, FilterSegments
  },
  props: ['filters', 'propFilters'],
  data: () => ({
    key: 0,
    nameFilter: {},
    idFilter: {},
    phoneFilter: {},
    emailFilter: {},
    ageFilter: {},
    segmentFilter: {},
    visitFrequencyFilter: {},
    activityFilter: {},
    availablePointOrStampFilter: {}
  }),
  computed: {
    ...mapGetters({
      marketingSetting: 'marketing/getMarketingSettings'
    }),
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.idFilter.key) {
        filters.push(this.idFilter)
      }
      if (this.phoneFilter.key) {
        filters.push(this.phoneFilter)
      }
      if (this.emailFilter.key) {
        filters.push(this.emailFilter)
      }
      if (this.ageFilter.key) {
        if (this.ageFilter.key === 'between') {
          const values = this.ageFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.ageFilter)
        }
      }
      if (this.segmentFilter.key) {
        filters.push(this.segmentFilter)
      }
      if (this.visitFrequencyFilter.key) {
        filters.push(this.visitFrequencyFilter)
      }
      if (this.activityFilter.key) {
        filters.push(this.activityFilter)
      }
      if (this.availablePointOrStampFilter.key) {
        if (this.availablePointOrStampFilter.key === 'between') {
          const values = this.availablePointOrStampFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.availablePointOrStampFilter)
        }
      }

      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        idFilter: this.idFilter,
        phoneFilter: this.phoneFilter,
        emailFilter: this.emailFilter,
        ageFilter: this.ageFilter,
        segmentFilter: this.segmentFilter,
        visitFrequencyFilter: this.visitFrequencyFilter,
        activityFilter: this.activityFilter
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.idFilter = this.propFilters?.idFilter || {}
      this.phoneFilter = this.propFilters?.phoneFilter || {}
      this.emailFilter = this.propFilters?.emailFilter || {}
      this.ageFilter = this.propFilters?.ageFilter || {}
      this.segmentFilter = this.propFilters?.segmentFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.nric.setData()
        this.$refs.phone.setData()
        this.$refs.email.setData()
        this.$refs.age.setData()
        this.$refs.segment.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.idFilter = {}
      this.phoneFilter = {}
      this.emailFilter = {}
      this.ageFilter = {}
      this.segmentFilter = {}
      this.visitFrequencyFilter = {}
      this.activityFilter = {}
      this.availablePointOrStampFilter = {}
    },
  }
}
</script>